module.exports = Function.call.bind(Object.prototype.hasOwnProperty);



//////////////////
// WEBPACK FOOTER
// ./~/react-redux/~/prop-types/lib/has.js
// module id = 792
// module chunks = 3